import type { LicensedProductCategoryName, LicenseTier } from "@packsize/authentication";
import { useMemo } from "react";

import { type ProductItem } from "../../types";

type CheckLicenseFunction = (product: LicensedProductCategoryName, tier: LicenseTier) => boolean | undefined;

export const useProductList = (hasLicense: CheckLicenseFunction): ProductItem[] =>
	useMemo(
		() => [
			{
				name: "migration",
				displayName: "Migration",
				value: false,
				mappedValue: "migration-v1",
				formattedScope: "Migration",
				hasLicense: () => true,
			},
			{
				name: "production",
				displayName: "Production",
				value: false,
				mappedValue: "production-api-v1",
				formattedScope: "Production",
				hasLicense: () => true,
			},
			{
				name: "import",
				displayName: "Import",
				value: false,
				mappedValue: "importapi",
				formattedScope: "Import",
				hasLicense: () => true,
			},
			{
				name: "cube",
				displayName: "Cube",
				value: false,
				mappedValue: "cubeapi",
				formattedScope: "Cube",
				hasLicense: () => hasLicense("DIM", "professional") === true,
			},
			{
				name: "dim",
				displayName: "Dim",
				value: false,
				mappedValue: "dimapi",
				formattedScope: "Dim",
				hasLicense: () => hasLicense("DIM", "professional") === true,
			},
		],
		[hasLicense],
	);

export const convertOauthScopes = (selectedProducts: string[]) => {
	return selectedProducts.map((product) => {
		switch (product) {
			case "migration-v1":
				return "Migration";
			case "production-api-v1":
				return "Production";
			case "importapi":
				return "Import";
			case "cubeapi":
				return "Cube";
			case "dimapi":
				return "Dim";
			default:
				return "";
		}
	});
};

export const populateProductCheckValue = (products: ProductItem[], selectedProducts: string[]) => {
	products.forEach((product) => {
		product.value = selectedProducts.includes(product.displayName);
	});

	return products;
};
